import type { AuthNamespace } from './namespace';

/**
 * Значение cookie по точному имени из строки `document.cookie`: пустое значение — null, битое url-кодирование —
 * значение как есть.
 */
export function readCookie(cookies: string, name: string): string | null {
    for (const raw of cookies ? cookies.split(';') : []) {
        const eq = raw.indexOf('=');
        if ((eq === -1 ? raw : raw.slice(0, eq)).trim() !== name) continue;
        const value = eq === -1 ? '' : raw.slice(eq + 1);
        if (!value) return null;
        try {
            return decodeURIComponent(value) || null;
        } catch {
            return value;
        }
    }
    return null;
}

/**
 * Заголовок double-submit CSRF для Account-эндпоинтов с `[RequireCsrfHeader]` (RefreshToken, SignOut) в cookie-режиме:
 * значение из не-httpOnly cookie namespace. Cookie нет — пустой объект (сервер ответит 403 `csrf_mismatch`).
 */
export function csrfHeaders(
    namespace: Pick<AuthNamespace, 'csrfCookie' | 'csrfHeader'>,
    cookies: string,
): Record<string, string> {
    const token = readCookie(cookies, namespace.csrfCookie);
    return token ? { [namespace.csrfHeader]: token } : {};
}
